<template>
  <button class="Drop-Menu-Item" @click="toStartBookmarkProcess">
    <div class="Drop-Menu-Item__svg-box">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path style="fill: var(--gray-600)" :style="get_starStyles" fill-rule="evenodd" clip-rule="evenodd" d="M7.99251 3.74246L7 1.42467L6.00749 3.74246C5.60969 4.67144 4.76636 5.30925 3.79469 5.416L1.37037 5.68236L3.18129 7.38118C3.90711 8.06207 4.22923 9.09407 4.0265 10.089L3.5207 12.5714L5.63241 11.3036C6.47879 10.7954 7.5212 10.7954 8.36758 11.3036L10.4793 12.5714L9.97349 10.089C9.77077 9.09407 10.0929 8.06207 10.8187 7.38118L12.6296 5.68235L10.2053 5.416C9.23363 5.30925 8.3903 4.67143 7.99251 3.74246ZM8.25005 0.844638C7.7678 -0.281547 6.23219 -0.281545 5.74995 0.844639L4.75744 3.16243C4.55854 3.62692 4.13688 3.94582 3.65104 3.9992L1.22672 4.26555C0.0487714 4.39497 -0.425757 5.91524 0.454145 6.74068L2.26506 8.4395C2.62797 8.77995 2.78904 9.29595 2.68767 9.79342L2.18186 12.2758C1.9361 13.482 3.17843 14.4216 4.20449 13.8055L6.31621 12.5377C6.7394 12.2836 7.2606 12.2836 7.68379 12.5377L9.79551 13.8055C10.8216 14.4216 12.0639 13.482 11.8181 12.2758L11.3123 9.79342C11.211 9.29595 11.372 8.77995 11.7349 8.4395L13.5459 6.74068C14.4258 5.91524 13.9512 4.39497 12.7733 4.26555L10.349 3.9992C9.86312 3.94582 9.44146 3.62692 9.24256 3.16243L8.25005 0.844638Z"></path>
      </svg>
    </div>
    {{ get_btnText }}
  </button>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import { toggleFavourites } from '@shared/api/posts/toggleFavourites.js';
  import { debounce } from 'lodash';
  import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay.js';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const ID = props.postId;
  const DEBOUNCE_TIME = 300;
  //--------------------------------------------
  const isBookmarked = ref(false);
  //--------------------------------------------
  onMounted(() => {
    initStates();
  });
  //--------------------------------------------
  //Получить пост для добавления в избраннное
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID]);
  //Получить информацию об информации наличия поста в избранном
  const get_bookmarkData = computed(() => get_post.value.reactions?.bookmarked);
  //Получить информацию о том, добавлен ли пост в избранное или нет
  const get_isBookmark = computed(() => get_bookmarkData.value.is_mine);
  //Получить текст для кнопки
  const get_btnText = computed(() => isBookmarked.value ? 'Убрать из избранного' : 'В избранное');
  //Проверить, отличается ли состояние избранного в хранилище от текущего состояния избранного
  const get_isBookmarkStateChanged = computed(() => get_isBookmark.value !== isBookmarked.value);
  //Стили для иконки избранного
  const get_starStyles = computed(() => {
    return (isBookmarked.value) ? 'fill: var(--orange-600)' : '';
  });
  //--------------------------------------------
  //Инициализировать состояния
  const initStates = () => {
    isBookmarked.value = get_isBookmark.value;
  }
  //Начать процесс переключения в букмарк
  const toStartBookmarkProcess = () => {
    toToggleCurrentBookmarkState();
    toToggleBookmark();
  }
  //Добавить/убрать пост из избранного
  const toToggleBookmark = debounce(async() => {
    if(!get_isBookmarkStateChanged.value) return;
    const data = {
      object_id: get_post.value.id,
      content_type: get_post.value.content_type,
    }
    try {
      await toggleFavourites(data);
      get_bookmarkData.value.is_mine = isBookmarked.value;
    } catch (error) {
      console.error('Ошибка при переключении избранного', error);
      callOverlay({ text: 'Ошибка при добавлении поста в избранное', color: 'red', icon: 'star' });
    } 
  }, DEBOUNCE_TIME);
  //Изменить текущее состояние избранного
  const toToggleCurrentBookmarkState = () => {
    isBookmarked.value = !isBookmarked.value;
  }
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>